import React, { useEffect, useState } from "react";
import axios from "axios";
const kasLogo = "/kas.png"; // Chemin vers votre logo KAS
const usdLogo = "/usd.png"; // Chemin vers votre logo USD
const kengyLogo = "/kengy.png"; // Chemin vers votre logo Kengy

const ProgressBar = () => {
  const [balanceKAS, setBalanceKAS] = useState(0);
  const [balanceKENGYUSD, setBalanceKENGYUSD] = useState(0);
  const goalKAS = 300000; // Objectif en KAS
  const goalUSD = 10000; // Objectif en USD
  const address =
    "kaspa:qpc598ujfwl5au2420aq9227l02pzfnmd8sa0pllz0g3wvu57gdpx9xrvnnuq";
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchBalanceKAS = async () => {
      try {
        const response = await axios.get(
          "https://api.kaspa.org/addresses/kaspa%3Aqpc598ujfwl5au2420aq9227l02pzfnmd8sa0pllz0g3wvu57gdpx9xrvnnuq/balance"
        );
        const balanceInKAS = response.data.balance / 1e8;
        setBalanceKAS(balanceInKAS);
      } catch (error) {
        console.error("Erreur lors de la récupération du solde KAS :", error);
      }
    };

    const fetchBalanceKENGY = async () => {
      try {
        const response = await axios.get(
          "https://api.kasplex.org/v1/krc20/address/kaspa%3Aqpc598ujfwl5au2420aq9227l02pzfnmd8sa0pllz0g3wvu57gdpx9xrvnnuq/token/KENGY"
        );
        const balanceInKENGY = response.data.result[0].balance / 1e8;

        const priceResponse = await axios.get(
          "https://api-v2-do.kas.fyi/token/krc20/transactions?ticker=KENGY"
        );
        const floorPrice =
          priceResponse.data.results[0].tokenInfo.price.floorPrice;

        // Récupération du prix de KAS en USD
        const kasPriceResponse = await axios.get(
          "https://api.kaspa.org/info/price?stringOnly=false"
        );
        const kasPriceInUSD = kasPriceResponse.data.price;

        // Calcul de la valeur de KENGY en KAS puis en USD
        const valueInKAS = balanceInKENGY * floorPrice;
        const valueInUSD = valueInKAS * kasPriceInUSD;

        setBalanceKENGYUSD(valueInUSD);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de la valeur KENGY :",
          error
        );
      }
    };

    fetchBalanceKAS();
    fetchBalanceKENGY();
  }, []);

  const progressPercentageKAS = Math.min((balanceKAS / goalKAS) * 100, 100);
  const progressPercentageUSD = Math.min(
    (balanceKENGYUSD / goalUSD) * 100,
    100
  );

  const handleCopy = () => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="max-w-md mx-auto p-4 bg-[#e5f7f9] rounded-lg shadow-lg card_donation">
      <div className="text-center mb-6 flex justify-between align-center d-flex items-center">
        <img
          src={kengyLogo}
          alt="Kengy Logo"
          className="w-24 h-24 mx-auto mb-4"
        />
        <h1 className="text-2xl font-bold text-[#5ad9d5]">
          KENGY CEX DEVELOPMENT
        </h1>
      </div>

      <DonationProgress
        title="KASPA Donation Progress"
        current={balanceKAS}
        goal={goalKAS}
        currency="KAS"
        percentage={progressPercentageKAS}
        logo={kasLogo}
      />
      <DonationProgress
        title="KENGY Donation Progress"
        current={balanceKENGYUSD}
        goal={goalUSD}
        currency="USD"
        percentage={progressPercentageUSD}
        logo={usdLogo}
      />

      <div className="my-4 p-4 rounded-lg shadow-lg bg-[#d8f0f2] text-center">
        <h2 className="text-lg font-bold">
          Send KAS or KENGY to this address:
        </h2>
        <div className="bg-white p-2 rounded-lg flex items-center justify-between my-2">
          <input
            type="text"
            value={address}
            readOnly
            className="flex-grow p-1 text-gray-700 bg-transparent outline-none"
            onFocus={(e) => e.target.select()}
          />
          <button
            className="bg-[#5ad9d5] text-white py-1 px-4 rounded-lg ml-2"
            onClick={handleCopy}
          >
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>
      </div>
    </div>
  );
};

const DonationProgress = ({
  title,
  current,
  goal,
  percentage,
  currency,
  logo,
}) => (
  <div className="my-4 p-4 rounded-lg shadow-lg bg-[#d8f0f2] flex items-center">
    <div className="flex-grow">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-bold">
          {title} ({currency})
        </h2>
        <img src={logo} alt={`${currency} logo`} className="w-8 h-8 mr-2" />
      </div>

      <div className="relative w-full h-6 bg-gray-300 rounded-full my-2">
        <div
          className="absolute progress_bar top-0 left-0 h-6 bg-[#5ad9d5] rounded-full flex items-center justify-center text-white text-sm font-bold"
          style={{ width: `${percentage}%` }}
        >
          {`${percentage.toFixed(2)}%`}
        </div>
      </div>
      <div className="flex justify-between text-sm">
        <span>
          Current: {current.toLocaleString()} {currency}
        </span>
        <span>
          Goal: {goal.toLocaleString()} {currency}
        </span>
      </div>
    </div>
  </div>
);

export default ProgressBar;
